import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { FormattedMessage } from 'react-intl';
import { Field, reduxForm } from 'redux-form';
import { InputFieldComponent } from '../../atoms/inputField/InputField.component';
import { isEmail, required } from '../../../utils/FormValidators';
import { EFormName } from '../../../config/form-names.config';
import { IContactInvited } from '../../../domain/contact.interface';

function InviteContactModalFormComponent(props: any) {
  const { showModal, handleClose, submitForm, handleSubmit } = props;
  function resetModal() {
    handleClose();
  }

  return (
    <Modal show={showModal} onHide={() => resetModal()} size='xl' centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <FormattedMessage id='organisms.invite-contact-modal-form.main_title' />
        </Modal.Title>
      </Modal.Header>
      <form
        name={EFormName.INVITE_CONTACT}
        autoComplete='off'
        onSubmit={handleSubmit((values: IContactInvited) => submitForm(values))}
      >
        <Modal.Body>
          <div className='form-field-container'>
            <FormattedMessage id='organisms.invite-contact-modal-form.alias-placeholder'>
              {(txt: any) => (
                <Field
                  name='alias'
                  component={InputFieldComponent}
                  label={txt}
                  validate={[required]}
                />
              )}
            </FormattedMessage>
            <FormattedMessage id='organisms.invite-contact-modal-form.email-placeholder'>
              {(txt: any) => (
                <Field
                  name='email'
                  component={InputFieldComponent}
                  label={txt}
                  validate={[required, isEmail]}
                />
              )}
            </FormattedMessage>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className='btn-lili form-button danger mb-3 cancel-btn'
            onClick={() => resetModal()}
          >
            <FormattedMessage id='common.cancel'></FormattedMessage>
          </button>
          <button className='btn-lili form-button  mb-3' type='submit'>
            <FormattedMessage id='common.send'></FormattedMessage>
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}

export default reduxForm({
  form: EFormName.INVITE_CONTACT,
})(InviteContactModalFormComponent);
